import usePageable from '@/composables/filters/usePageable';
import {ref} from 'vue';

export default function () {
  const pageable = usePageable();
  pageable.sortField.value = 'id';

  const filters = ref({
    code: {value: null}
  });

  function getQueryParams() {
    const params = pageable.getQueryParams();

    if (filters.value.code?.value != null) {
      params['code'] = filters.value.code.value;
    }

    return params;
  }

  return {
    pageable,
    filters,
    getQueryParams,
  }
}


